import { providerFormToQuery as formToQuery } from './providerFormToQuery';
import { providerQueryToForm as queryToForm } from './providerQueryToForm';

export default { queryToForm, formToQuery };
